module.exports = __webpack_public_path__ + "img/horizontal_4_6_5012.65c9c546.png";